export default "__VITE_ASSET__DAMCvqJi__"